import { section } from "@/neon";
import { animatePage } from "@/lib/animation";

section("page", {
  onLoad() {
    this.animatePage = animatePage(this.container);
  },
  onUnload() {
    this.animatePage?.destroy();
  },
});
